module.exports = __webpack_public_path__ + "img/9.0cc5c236.jpg";